import { Row } from "@tanstack/react-table";
import { User } from "@/services/cloudchipr.api";
import { formatDate } from "@/utils/helpers/date-time/datetime-format";

export const usersLastLoginFilterFn = (
  row: Row<User>,
  _: string,
  keyword: string,
) => {
  const lastLoginDate = row.original.last_time_logged_in_at;

  if (!lastLoginDate) {
    return false;
  }

  const filterValue = keyword.toLowerCase().trim();
  const formattedDate = formatDate(lastLoginDate, {
    type: "dateTime",
  }).toLowerCase();

  return formattedDate.includes(filterValue);
};
